import React from 'react';
import { useMediaQuery } from '@material-ui/core';

import ImageMargin from '../images/frame/type/margin.jpg';
import ImageNoMargin from '../images/frame/type/no_margin.jpg';

import ImageFrame1 from '../images/frame/colors/f1.jpg';
import ImageFrame2 from '../images/frame/colors/f2.jpg';
import ImageFrame3 from '../images/frame/colors/f3.jpg';
import ImageFrame4 from '../images/frame/colors/f4.jpg';
import ImageFrame5 from '../images/frame/colors/f5.jpg';
import ImageFrame6 from '../images/frame/colors/f6.jpg';
import ImageFrame7 from '../images/frame/colors/f7.jpg';
import ImageFrame8 from '../images/frame/colors/f8.jpg';

const frameColor = [
  { value: 'f1', image: ImageFrame1, label: 'Svart' },
  { value: 'f2', image: ImageFrame2, label: 'Vit' },
  { value: 'f3', image: ImageFrame3, label: 'Ek' },
  { value: 'f4', image: ImageFrame4, label: 'Valnöt' },
  { value: 'f5', image: ImageFrame5, label: 'Körsbär' },
  { value: 'f6', image: ImageFrame6, label: 'Grå' },
  { value: 'f7', image: ImageFrame7, label: 'Guld' },
  { value: 'f8', image: ImageFrame8, label: 'Silver' },
];

const frameType = [
  { value: 'margin', image: ImageMargin, label: 'Med marginal' },
  { value: 'no_margin', image: ImageNoMargin, label: 'Utan marginal' },
];

const CustomOverlayDrawer = ({ openFrameMenu, handleToggleChange, setFrameCode, setFrameType, setToggleState }) => {
  const isMobileView = useMediaQuery('(max-width:600px)');

  if (!openFrameMenu) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={handleToggleChange}
        style={{
          position: 'fixed', inset: 0, zIndex: 1400,
          backgroundColor: 'rgba(0,0,0,0.35)', backdropFilter: 'blur(3px)',
          animation: 'fadeIn 0.2s ease',
        }}
      />

      {/* Modal */}
      <div style={{
        position: 'fixed', zIndex: 1401,
        top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: isMobileView ? '92%' : '440px', maxHeight: '85vh',
        backgroundColor: '#fff', borderRadius: '20px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        overflow: 'hidden', animation: 'slideUp 0.25s ease',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '20px 24px 16px', borderBottom: '1px solid #f0f0f0',
        }}>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: '#161825' }}>
            Välj ram
          </h2>
          <button
            onClick={handleToggleChange}
            style={{
              width: 36, height: 36, borderRadius: '50%', border: 'none',
              backgroundColor: '#f5f5f5', cursor: 'pointer', display: 'flex',
              alignItems: 'center', justifyContent: 'center', fontSize: '18px',
              color: '#666', transition: 'background-color 0.15s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#eee'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
          >
            ✕
          </button>
        </div>

        {/* Scrollable content */}
        <div style={{ padding: '20px 24px 24px', overflowY: 'auto', maxHeight: 'calc(85vh - 80px)' }}>
          {/* Frame color section */}
          <p style={{
            fontSize: '12px', fontWeight: 600, textTransform: 'uppercase',
            letterSpacing: '0.1em', color: '#888', margin: '0 0 14px 0',
          }}>
            Färg
          </p>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobileView ? 'repeat(4, 1fr)' : 'repeat(4, 1fr)',
            gap: '10px', marginBottom: '28px',
          }}>
            {frameColor.map((frame) => (
              <button
                key={frame.value}
                onClick={() => {
                  setFrameCode(frame.value);
                  setToggleState(true);
                  handleToggleChange();
                }}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
                  padding: '10px 6px', borderRadius: '14px', cursor: 'pointer',
                  border: '2px solid #eee', backgroundColor: '#fff',
                  transition: 'all 0.15s ease',
                }}
                onMouseOver={(e) => { e.currentTarget.style.borderColor = '#161825'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}
                onMouseOut={(e) => { e.currentTarget.style.borderColor = '#eee'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                <div style={{
                  width: isMobileView ? 48 : 56, height: isMobileView ? 48 : 56,
                  borderRadius: '10px', overflow: 'hidden',
                  border: '1px solid #e5e5e5',
                }}>
                  <img
                    src={frame.image} alt={frame.label}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <span style={{ fontSize: '11px', color: '#555', fontWeight: 500 }}>
                  {frame.label}
                </span>
              </button>
            ))}
          </div>

          {/* Frame type section */}
          <p style={{
            fontSize: '12px', fontWeight: 600, textTransform: 'uppercase',
            letterSpacing: '0.1em', color: '#888', margin: '0 0 14px 0',
          }}>
            Stil
          </p>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px',
          }}>
            {frameType.map((frame) => (
              <button
                key={frame.value}
                onClick={() => {
                  setFrameType(frame.value);
                  setToggleState(true);
                  handleToggleChange();
                }}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px',
                  padding: '16px 12px', borderRadius: '14px', cursor: 'pointer',
                  border: '2px solid #eee', backgroundColor: '#fff',
                  transition: 'all 0.15s ease',
                }}
                onMouseOver={(e) => { e.currentTarget.style.borderColor = '#161825'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}
                onMouseOut={(e) => { e.currentTarget.style.borderColor = '#eee'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                <div style={{
                  width: isMobileView ? 80 : 100, height: isMobileView ? 80 : 100,
                  borderRadius: '12px', overflow: 'hidden',
                  border: '1px solid #e5e5e5',
                }}>
                  <img
                    src={frame.image} alt={frame.label}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <span style={{ fontSize: '13px', color: '#333', fontWeight: 600 }}>
                  {frame.label}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { opacity: 0; transform: translate(-50%, -46%); } to { opacity: 1; transform: translate(-50%, -50%); } }
      `}</style>
    </>
  );
};

export default CustomOverlayDrawer;
